/**
 * Returns a randomly-generated id w/ an optional prefix.
 *
 * Note: if you're using jest snapshots, make sure to memoize this id!
 *
 * const id = useMemo(() => genId("some-prefix"), []);
 */
export const genId = (() => {
  return prefix => {
    const randomString = (Math.random() + 1).toString(36).substring(2, 8);
    return `lodestar-utils-${prefix ? prefix + "-" : ""}gen-id-${randomString}`;
  };
})();
//# sourceMappingURL=genId.js.map